export const getBrand = () => {
    const url = window.location.href;
    if(url.indexOf('proartcc') != -1){
        return 'ProArt';
    }else{
        return 'ASUS';
    }
}